import { CORE_RE } from '../../store/modules/raw-sql/constants'
import { get, isUndefined } from 'lodash'
import { compile } from 'vue-template-compiler'
import { SOURCE_TYPES } from '../list-new/lib/list-constants'
import { VARIABLE_TYPES } from '../../utils'

export const TEMPLATED_LIST_PATHS_TO_WATCH = {
  SOURCE_TYPE: 'root.base.listSettings.sourceType',
}
const MULTIPLE_ROOT_EL_ERROR = 'Component template should contain exactly one root element. If you are using v-if on multiple elements, use v-else-if to chain them instead.'

/**
 *
 * @param value
 * @returns {null|*}
 */
export function cleanValue(value) {
  //ures tomb nem jatszik
  if (Array.isArray(value) && !value.length) {
    return null
  }

  //ures string nem jatszik
  if (typeof value === VARIABLE_TYPES.STRING && !value.length) {
    return null
  }

  return value
}

function hasSingleRoot(template) {
  const compiled = compile(template)
  return !(compiled.errors.length && compiled.errors.includes(MULTIPLE_ROOT_EL_ERROR))
}

export function replaceCoreParams(template, CORE) {
  let wrappedTemplate = hasSingleRoot(template)
    ? template
    : `<div>${template}</div>`
  const coreMatches = template.match(CORE_RE)
  if (!coreMatches) return wrappedTemplate

  coreMatches.forEach((match) => {
    if (!match) return
    const paramPath = match.replace(/:CORE\.|:DOTO\./gm, '')
    let refVal = get(CORE, paramPath) // @regex matches CORE or DOTO with or without colon
    if (!isUndefined(refVal)) {
      wrappedTemplate = wrappedTemplate.replaceAll(match, refVal)
    }
  })

  return wrappedTemplate
}

export function replaceSourceList({
  dispatch,
  sourceType,
  panelType,
  dataSources,
}) {
  const schema = {
    enum: [],
    options: {
      enum_titles: [],
    },
  }
  switch (sourceType) {
    case SOURCE_TYPES.FORM:
      schema.enum = [ '', ...dataSources.mongoIdSource.map((value) => value.value) ]
      schema.options.enum_titles = [ '', ...dataSources.mongoIdSource.map((value) => value.title) ]
      break
    case SOURCE_TYPES.QUERY:
      schema.enum = [ '', ...dataSources.queryIdSource.map((value) => value.value) ]
      schema.options.enum_titles = [ '', ...dataSources.queryIdSource.map((value) => value.title) ]
      break
    default:
      break
  }
  dispatch('updateEditorSchema', { panelType, path: [ 'list', 'idSource' ], schema })
}